import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Cookies() {
  const contact = siteConfig.contact || {};

  return (
    <main className="content-page legal-page privacy-page">
      <header className="page-hero page-hero--compact">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">Your choices</p>
          <h1>Cookie policy</h1>
          <p className="page-hero__lede">How this site uses browser storage and similar technologies.</p>
        </div>
      </header>
      <section className="page-section page-shell legal-layout">
        <nav className="policy-nav" aria-label="Cookie policy sections">
          <p className="eyebrow">Contents</p>
          <a href="#cookie-overview">Overview</a>
          <a href="#cookie-types">Cookie types</a>
          <a href="#cookie-control">Your controls</a>
          <a href="#cookie-contact">Contact</a>
        </nav>
        <article className="prose legal-copy">
          <section id="cookie-overview">
            <h2>1. Overview</h2>
            <p>Cookies and local browser storage are small pieces of data used to keep a site working, remember choices, and understand performance. This front-end store currently keeps cart and wishlist choices in your browser and does not operate advertising cookies.</p>
          </section>
          <section id="cookie-types">
            <h2>2. Types of cookies</h2>
            <ul>
              <li><strong>Essential:</strong> needed for core functions such as navigation, security, checkout, and cart continuity.</li>
              <li><strong>Preference:</strong> remember settings you choose for a future visit.</li>
              <li><strong>Analytics:</strong> may help measure aggregated site usage when an analytics provider is connected.</li>
              <li><strong>Marketing:</strong> may support relevant advertising only if added in the future and permitted by your choices and applicable law.</li>
            </ul>
          </section>
          <section id="cookie-control">
            <h2>3. Your controls</h2>
            <p>You can clear or block cookies and local storage in your browser settings. Blocking essential storage may prevent the cart, checkout, or saved items from working. If optional cookie tools are introduced, this page and the site controls will be updated.</p>
            <p>For more about personal information, read our <Link to="/privacy">privacy policy</Link>.</p>
          </section>
          <section id="cookie-contact">
            <h2>4. Contact</h2>
            <p>Questions about cookies can be sent to <a href={`mailto:${contact.email}`}>{contact.email}</a>.</p>
            {contact.address && <address>{contact.address}</address>}
          </section>
        </article>
      </section>
    </main>
  );
}

export default Cookies;
